import './TemplateDashboard.scss'
import TemplateTable from '../../components/TemplateTable/TemplateTable'

function TemplateDashboard() {
  return (
    <div className="container">
      <div className="template-list">
        <TemplateTable />
      </div>
    </div>
  )
}
export default TemplateDashboard
